import { useSyncExternalStore } from "react";

import { type ConsentState, cookieConsentStore } from "@/lib/cookie-consent";

/**
 * The visitor's cookie choice, kept in sync across renders and tabs.
 *
 * `useSyncExternalStore` rather than `useState` + `useEffect`, for the same
 * reason as `usePrefersReducedMotion`: the value already lives outside React,
 * and reading it in an effect paints one frame first — here that frame is a
 * consent banner flashing at someone who already answered.
 *
 * The server snapshot reports "not decided". Marketing pages are prerendered
 * to static HTML with `failOnError: true`, so anything that renders from this
 * must render nothing on the server; the banner does that by being lazy behind
 * a `null` Suspense fallback.
 */
export function useCookieConsent(): ConsentState {
  return useSyncExternalStore(
    cookieConsentStore.subscribe,
    cookieConsentStore.getSnapshot,
    cookieConsentStore.getServerSnapshot,
  );
}
